@if (plan$ | async; as plan) {
  <div
    cdkDropList
    [cdkDropListData]="listData$ | async"
    [cdkDropListConnectedTo]="stepDragDrop.lists$ | async"
    (cdkDropListDropped)="stepDragDrop.drop($event)"
  >
    @for (
      step of steps$ | async;
      track trackByUuidFn($index, step);
      let index = $index;
      let last = $last
    ) {
      @if (
        (canAddStep$ | async) && index === (firstUnscheduledIndex$ | async)
      ) {
        <pr-add-step-button
          [hasSelection]="hasSelection$ | async"
          (clicked)="addStepBefore(plan, step)"
        />
      }
      <div [ngClass]="{ hidden: stepComponent.displayStep() === false }">
        <pt-drag-box
          class="my-2"
          cdkDrag
          cdkDragPreviewClass="drag-preview-transparent"
          [cdkDragData]="step"
          [cdkDragDisabled]="step | map: dragDisabled$ : this | async"
        >
          <mat-icon cdkDragHandle class="drag-handle">drag_handle</mat-icon>

          <pr-treatment-step
            #stepComponent
            [step]="step"
            [plan]="plan"
            (stepChanged)="updateStep($event, step)"
            (stepDeleted)="deleteStep($event)"
            (moveTreatmentsHere)="moveTreatmentsToStep.emit(step)"
            (updateChartable)="updateSurfaces($event, plan, step)"
          />
        </pt-drag-box>
      </div>
      @if (
        (canAddStep$ | async) &&
        stepComponent.displayStep() !== false &&
        stepComponent.status() === 'unscheduled' &&
        !last
      ) {
        <pr-add-step-button
          [hasSelection]="hasSelection$ | async"
          (clicked)="addStep(plan, step)"
        />
      }
    }
    @if (canAddStep$ | async) {
      <pr-add-step-button
        [hasSelection]="hasSelection$ | async"
        (clicked)="addStep()"
      />
    }
  </div>
}
